import React from 'react';
import './CartDrawer.css';
import Turnstile from './Turnstile';

const CartDrawer = ({ cart, onClose, onUpdateQty, onRemove, comments, onCommentsChange, onSubmit, deliveryFee, submitting, error, onTurnstileToken, turnstileReady, turnstileResetKey }) => {
  const subtotal = cart.reduce((s, i) => s + Number(i.price) * Number(i.quantity), 0);
  const total = subtotal + Number(deliveryFee);

  return (
    <>
      <div className="drawer-overlay" onClick={onClose} />
      {submitting && (
        <div className="cart-submitting-overlay">
          <div className="cart-submitting-box">
            <div className="cart-spinner" />
            <p>Placing your order…</p>
            <p className="cart-submitting-note">Please don't close or refresh this page.</p>
          </div>
        </div>
      )}
      <div className="cart-drawer">
        <div className="cart-drawer-header">
          <h2>Your Cart</h2>
          <button className="cart-drawer-close" onClick={onClose}>×</button>
        </div>

        <div className="cart-drawer-body">
          {cart.length === 0 ? (
            <p className="cart-empty">Your cart is empty.</p>
          ) : (
            <ul className="cart-items">
              {cart.map(item => (
                <li key={item.id} className="cart-item">
                  <div className="cart-item-name">
                    {item.size} {item.foodName}
                    <button className="cart-remove-btn" onClick={() => onRemove(item.id)}>×</button>
                  </div>
                  <div className="cart-item-controls">
                    <button
                      className="cart-qty-btn"
                      onClick={() => onUpdateQty(item.id, item.quantity - 1)}
                      disabled={item.quantity <= item.minQty}
                    >–</button>
                    <span className="cart-qty-val">{item.quantity}</span>
                    <button
                      className="cart-qty-btn"
                      onClick={() => onUpdateQty(item.id, item.quantity + 1)}
                      disabled={item.quantity >= item.maxQty}
                    >+</button>
                    <span className="cart-item-line-total">
                      {item.quantity} × ${Number(item.price).toFixed(2)} = ${(Number(item.price) * Number(item.quantity)).toFixed(2)}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          )}

          <div className="cart-comments-section">
            <label className="cart-comments-label">Comments / Special Requests</label>
            <textarea
              className="cart-comments-textarea"
              placeholder="Any special requests or notes..."
              value={comments}
              onChange={e => onCommentsChange(e.target.value)}
            />
          </div>
        </div>

        <div className="cart-drawer-footer">
          <div className="cart-totals">
            <div className="cart-total-row">
              <span>Subtotal</span>
              <span>${subtotal.toFixed(2)}</span>
            </div>
            <div className="cart-total-row">
              <span>Delivery fee</span>
              <span>{deliveryFee > 0 ? `$${deliveryFee.toFixed(2)}` : 'Free'}</span>
            </div>
            <div className="cart-total-row cart-grand-total">
              <span>Total</span>
              <span>${total.toFixed(2)}</span>
            </div>
          </div>
          {error && (
            <div className="cart-error">{error}</div>
          )}
          <Turnstile onToken={onTurnstileToken} resetKey={turnstileResetKey} />
          <button
            className="cart-checkout-btn"
            onClick={onSubmit}
            disabled={cart.length === 0 || submitting || !turnstileReady}
          >
            {submitting ? 'Placing Order…' : 'Place Order'}
          </button>
        </div>
      </div>
    </>
  );
};

export default CartDrawer;
